<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" class="ml-3">
        NOVO EVENTO
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"
              >Cadastro de {{ isAT ? "Agenda" : "Encontro" }}</slot
            >
          </v-col>
          <v-col class="text-right">
            <v-icon @click="close()" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <app-group-solution-combobox
              :filter="payload"
              @onChange="getMembers"
              :name="
                isAT
                  ? 'Grupo/Iniciativa'
                  : isSala
                  ? 'Grupo'
                  : 'Grupo de Trabalho'
              "
            >
            </app-group-solution-combobox>
          </v-col>
        </v-row>

        <v-row v-if="estado !== 'SC'">
          <v-col sm="6">
            <v-text-field
              :label="`Nome ${isAT ? 'da agenda' : 'do encontro'}`"
              v-model="payload.nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00h:00m"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.duracaoString"
              v-mask="['##:##', '###:##', '####:##']"
              label="Duração do Evento"
              placeholder="00h:00m"
              @blur="setFimString()"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mascara="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00h:00m"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="payload.solucoesEvento.length > 0">
          <v-col md="9" sm="9" lg="9">
            <v-text-field
              :label="`${
                isAT ? 'Iniciativa da agenda' : 'Solução do encontro'
              }`"
              v-model="payload.solucoesEvento[0].nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row
          v-if="
            payload.solucoesEvento.length > 0 &&
            payload.solucoesEvento[0].monitoramento === 2
          "
        >
          <v-col md="3" sm="3" lg="3">
            <v-radio-group
              v-model="payload.solucoesEvento[0].tipoMonitoramentoEvento"
            >
              <v-radio label="Trabalho de Escritório" value="1"></v-radio>
              <v-radio label="Visita" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <template v-if="payload.solucoesEvento.length > 0">
          <v-row>
            <v-col md="9" sm="9" lg="9">
              <v-combobox
                v-model="payload.tarefasEvento"
                :items="tarefas"
                chips
                clearable
                :label="`${isAT || isGov ? 'Atividades' : 'Tarefas'}`"
                item-value="municipioTarefaId"
                multiple
                :item-disabled="disableTasks"
                :menu-props="{ auto: true }"
              >
                <template v-slot:item="{ item, attrs }">
                  <template v-if="!attrs.disabled">
                    <v-icon>{{ icon(attrs.inputValue) }}</v-icon>
                  </template>
                  <div class="mr-1 ml-1">
                    {{ item.nome }} | Horas: {{ item.horas }}h
                  </div>

                  <template v-if="attrs.disabled">
                    <v-icon color="rgba(0, 0, 0, 0.38)">mdi-check</v-icon>
                  </template>
                </template>
                <template v-slot:selection="{ attrs, item, disabled }">
                  <v-chip close @click:close="removeTarefa(item)">
                    <strong>{{ item.nome }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col
              md="3"
              sm="3"
              lg="3"
              v-if="
                !novaTarefa &&
                (this.isFullAdmin ||
                  (this.config.podeCriarTarefaNoCalendario &&
                    this.groupsConfig.podeCriarTarefaNoCalendario))
              "
            >
              <v-btn color="primary" @click="novaTarefa = true">
                + Tarefa</v-btn
              >
            </v-col>
          </v-row>

          <v-row v-if="novaTarefa">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ payload.novaTarefa.nome || "Nova Tarefa" }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-col
                    ><v-text-field
                      v-model="payload.novaTarefa.nome"
                      label="Nome"
                    >
                    </v-text-field
                  ></v-col>

                  <v-col class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      @click="
                        () => {
                          novaTarefa = false;
                          payload.novaTarefa = {};
                        }
                      "
                      >Remover</v-btn
                    >
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </template>
        <v-row>
          <v-col md="9" sm="9" lg="9">
            <v-select
              v-model="payload.convidadosEvento"
              :items="membros"
              chips
              label="Membros"
              item-text="nome"
              multiple
              :return-object="true"
            >
              <template slot="no-data"> Nenhum membro retornado </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-modal-insert-member
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :municipioId="payload.municipioId"
              :grupo="payload.grupo"
              @onSave="getMembers"
            >
              <template v-slot:title :edit="false"> Cadastrar Membro </template>
            </app-modal-insert-member>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row
          v-if="
            isFullAdmin ||
            (config.verParcialAcaoFinalizada &&
              groupsConfig.verParcialAcaoFinalizada)
          "
        >
          <v-col class="tipos">
            <div>
              <v-radio-group v-model="payload.encontroType" row>
                <v-radio label="Parcial" value="Parcial"></v-radio>
                <v-radio
                  label="Ação Finalizada"
                  value="Ação Finalizada"
                ></v-radio>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="isAT">
          <v-col>
            <v-checkbox
              v-model="payload.sensibilizacao"
              id="sensibilizacao"
              color="primary"
              label="Sensibilização"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="payload.emAndamento"
              id="emAndamento"
              color="primary"
              label="Em Andamento"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="payload.finazacao"
              id="finazacao"
              color="primary"
              label="Finalização"
            />
          </v-col>
        </v-row>

        <v-row v-if="repeatedInvite">
          <v-col>
            <v-alert border="top" color="red lighten-2" dark>
              Já existe outro evento para o mesmo membro na mesma data
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close()">Fechar</v-btn>
        <v-btn color="info" outlined text @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  cityAPI,
  AppGroupSolutionCombobox,
  citySolutionAPI,
} from "@/modules/city";
import { meetingAPI } from "@/modules/calendar";
import { memberAPI } from "@/modules/city/components/MemberAPI";
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import { mapActions, mapGetters } from "vuex";
import AppModalInsertMember from "@/modules/city/components/group/ModalInsertMember";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  name: "AppModalInsertMeeting",
  props: {
    dialog: { type: Boolean, default: false },
    meetings: { type: Array },
  },
  components: {
    AppGroupSolutionCombobox,
    AppModalInsertMember,
  },
  data() {
    return {
      panel: 0,
      payload: {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        observacoes: null,
        novaTarefa: {},
        encontroType: "Parcial",
      },
      menu: "",
      menu2: "",
      date: null,
      time: null,
      eixos: [],
      tarefas: [],
      membros: [],
      showDialog: this.dialog,
      municipio: {},
      novaTarefa: false,

      estado: this.$store.state.uf,
      repeatedInvite: false,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    icon(item) {
      if (item) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    },
    close() {
      this.showDialog = false;
      delete this.payload;
      this.payload = {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        observacoes: null,
        novaTarefa: {},
        encontroType: "Parcial",
      };
      this.$set(this.payload, {
        nome: null,
        grupoId: 0,
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: [],
        convidadosEvento: [],
        observacoes: null,
        novaTarefa: {},
        encontroType: "Parcial",
      });

      this.$forceUpdate();
    },
    getTasks() {
      this.setLoading(true);
      cityTaskAPI
        .getTasks(
          this.payload.solucoesEvento.map(function (item) {
            return item.municipioSolucaoId;
          })
        )
        .then((resp) => {
          this.tarefas = resp.data.filter((response) => {
            return !response.desabilitado;
            // this.tarefas = resp.data
          });

          if (
            !this.isFullAdmin &&
            (!this.config.visualizaTarefasExecutadas ||
              !this.groupsConfig.visualizaTarefasExecutadas)
          ) {
            this.tarefas = this.tarefas.filter((item) => !item.realizada);
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${
              this.isAT || this.isGov ? "atividades" : "tarefas"
            }`
          );
        });
    },
    disableTasks(item) {
      return item.realizada;
    },
    getMembers() {
      this.setLoading(true);
      memberAPI
        .getMembersByCity(this.payload.municipioId)
        .then((resp) => {
          this.membros = resp.data;
          this.removeSolucao();
          this.getMembersByGroup();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    getMembersByGroup() {
      memberAPI
        .getMembers(this.payload.grupo.grupoId)
        .then((resp) => {
          if (
            this.isFullAdmin ||
            (this.config.carregaMembrosGrupos &&
              this.groupsConfig.carregaMembrosGrupos)
          )
            this.payload.convidadosEvento = resp.data;
          else this.payload.convidadosEvento = [];
          this.payload.grupoId = this.payload.grupo.grupoId;
          this.getName();
          if (this.payload.solucoesEvento[0] !== undefined) {
            this.getTasks();
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter membros");
        });
    },
    getName() {
      meetingAPI
        .getName(this.payload)
        .then((resp) => {
          this.payload.nome = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Nome do Evento");
        });
    },
    removeSolucao() {
      if (this.payload.solucoesEvento.length > 0) {
        this.payload.solucoesEvento.splice(
          this.payload.solucoesEvento.indexOf(
            this.payload.grupo.municipioSolucao
          ),
          1
        );
      }
      this.payload.solucoesEvento = [...this.payload.solucoesEvento];
      this.tarefas = [];
      this.chipsTarefas = [];
      if (this.payload.grupo.municipioSolucao) {
        this.payload.solucoesEvento.push(this.payload.grupo.municipioSolucao);
      }
      this.removeTarefa();
    },
    removeTarefa(item) {
      if (this.payload.tarefasEvento.length > 0) {
        this.payload.tarefasEvento.splice(
          this.payload.tarefasEvento.indexOf(item),
          1
        );
      } else {
        this.payload.tarefasEvento = [];
      }
      this.payload.tarefasEvento = [...this.payload.tarefasEvento];
    },
    removeMembro(item) {
      this.payload.convidadosEvento.splice(
        this.payload.convidadosEvento.indexOf(item),
        1
      );
      this.payload.convidadosEvento = [...this.payload.convidadosEvento];
    },
    alertaSalvarEncontro() {
      Swal.fire({
        title: `Atenção`,
        text: `Deseja criar o evento com data inicial ${this.payload.inicioString} e data fim ${this.payload.fimString}?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.saveEncontro();
        }
      });
    },
    alertTarefa() {
      Swal.fire({
        title: "Atenção!",
        text: ` ${this.isAT ? "Esta agenda" : "Este encontro"} não possui ${
          this.isAT || this.isGov ? "atividades" : "tarefas"
        } selecionadas. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (result.isConfirmed) {
          this.alertaSalvarEncontro();
        }
      });
    },
    async save() {
      if (!this.payload.inicioString || this.payload.inicioString.length < 16) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de início do evento"
        );
      } else if (
        !this.payload.fimString ||
        this.payload.fimString.length < 16
      ) {
        this.$notification.error(
          "É obrigatório o preenchimento de data e hora de término do evento"
        );
      } else if (
        moment(this.payload.fimString, "DD/MM/YYYY HH:mm").isBefore(
          moment(this.payload.inicioString, "DD/MM/YYYY HH:mm")
        )
      ) {
        this.$notification.error(
          "A data final do evento não pode ser menor que a data inicial do evento"
        );
      } else if (this.repeatedMeetings() && !this.repeatedInvite) {
        this.$notification.error(
          "Já existe outro evento do mesmo grupo na mesma data"
        );
      } else {
        if (
          this.payload.tarefasEvento.length == 0 &&
          !this.payload.novaTarefa.nome
        ) {
          this.alertTarefa();
        } else {
          this.alertaSalvarEncontro();
        }
      }
    },
    async saveEncontro() {
      this.setLoading(true);
      const tarefasId = this.payload.tarefasEvento
        .map((item) => item.municipioTarefaId)
        .join(",");

      let errorHours;

      if (
        this.payload.solucoesEvento &&
        this.payload.solucoesEvento.length > 0
      ) {
        const { municipioSolucaoId, maxHoras } = this.payload.solucoesEvento[0];

        if (tarefasId && municipioSolucaoId && maxHoras)
          await citySolutionAPI
            .verifyHoursSolution(tarefasId, municipioSolucaoId)
            .then((data) => {
              if (data.data.errorMaxHour) {
                errorHours = "error";

                this.setLoading(false);

                this.$notification.error(
                  "A(s) tarefa(s) ultrapassa(m) o limite de horas da solução"
                );
              }
            });
      }

      if (!errorHours) {
        if (this.payload.novaTarefa.nome)
          this.payload.tarefasEvento.push({
            ...this.payload.novaTarefa,
            municipioSolucaoId: this.payload.grupo.municipioSolucaoId,
            municipioId: this.payload.municipioId,
            descricao: null,
            horas: parseInt(this.payload.duracaoString),
            status: 1,
            realizada: 1,
            desabilitado: 0,
            dataFinalizacao: null,
            dataConclusao: null,
          });

        meetingAPI
          .create(this.payload)
          .then((resp) => {
            this.$emit("onSave");
            this.showDialog = false;
            this.payload.nome = null;
            this.payload.grupoId = 0;
            this.payload.inicioString = null;
            this.payload.duracaoString = null;
            this.payload.fimString = null;
            this.payload.municipioId = this.$route.params.id;
            this.payload.grupo = [];
            this.payload.solucoesEvento = [];
            this.payload.tarefasEvento = [];
            this.payload.convidadosEvento = [];
            this.payload.observacoes = null;
            this.payload.novaTarefa = {};
            this.novaTarefa = false;
            this.tarefasEvento = [];
            this.membros = [];
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              `Erro ao cadastrar ${this.isAT ? "agenda" : "encontro"}`
            );
          });
      }
    },
    loadCity() {
      this.setLoading(true);
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.municipio = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    repeatedMeetings() {
      let repeated = false;

      this.meetings.forEach((meeting) => {
        if (
          this.payload.grupoId === meeting.grupoId &&
          this.payload.inicioString === meeting.inicioString
        ) {
          repeated = true;

          this.payload.convidadosEvento.forEach((convidadoEvento) => {
            if (
              meeting.convidadosEvento.some(
                (convidado) => convidado.membroId === convidadoEvento.membroId
              )
            ) {
              this.repeatedInvite = true;
            }
          });
        }
      });

      return repeated;
    },
    setInicioString() {
      if (!this.payload.fimString || !this.payload.inicioString) return;
      var a = moment(this.payload.fimString, "DD/MM/YYYY HH:mm");
      var b = moment(this.payload.inicioString, "DD/MM/YYYY HH:mm");
      var diff_s = a.diff(b, "seconds");
      this.payload.duracaoString = moment
        .utc(moment.duration(diff_s, "seconds").asMilliseconds())
        .format("HH:mm");

      this.$forceUpdate();
      return this.payload.fimString;
    },
    setFimString() {
      let inicioDate = moment(this.payload.inicioString, "DD/MM/YYYY HH:mm")
        .add(this.payload.duracaoString.substring(0, 2), "hours")
        .format("DD/MM/YYYY HH:mm");
      this.payload.fimString = moment(inicioDate, "DD/MM/YYYY HH:mm")
        .add(this.payload.duracaoString.substring(3), "minutes")
        .format("DD/MM/YYYY HH:mm");
      this.$forceUpdate();
      return this.payload.fimString;
    },
  },
  computed: {
    ...mapGetters(["loading", "isAT", "isFullAdmin", "isSala", "isGov"]),
  },
  created() {
    this.loadCity();
  },
};
</script>
<style lang="scss" scoped>
.executed {
  color: #fff;
  background: #0000003b;
  font-size: 10px;
  padding: 5px;
  border-radius: 30px;
  margin-right: 10px;
}
</style>
